import { BoardBasisCode } from '@libs/trip-planner-interfaces';
import { assertValue } from '@libs/utils';

export function toBoardBasisCode(boardBasis: string): BoardBasisCode {
  const boardBasisCode = Object.values(BoardBasisCode).find(
    (value) => value === boardBasis
  );

  assertValue(boardBasisCode, 'Unknown BoardBasisCode');

  return boardBasisCode;
}
